import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "grid-3 gap-sm" }
const _hoisted_2 = { class: "panel span-2" }
const _hoisted_3 = {
  key: 0,
  class: "panel"
}

import { onMounted, ref, watch } from 'vue';
import { LawFirm, LawFirmCreate, useLawFirm } from '../LawFirm';
import { ErrorBag, handleFormError } from '@/core/common';
import { CompanyRecord } from '@/modules/company_record/CompanyRecord';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppButton from '@/core/components/form/AppButton.vue';
import PageLayout from '@/core/components/PageLayout.vue';
import AppInput from '@/core/components/form/AppInput.vue';
import AppCompanyRecordInput from '@/modules/company_record/components/AppCompanyRecordInput.vue';
import AppCheck from '@/core/components/form/AppCheck.vue';

interface LawFirmFormProps {
	pageTitle: string;
	lawFirm: LawFirm | LawFirmCreate;
	forCreate: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LawFirmForm',
  props: {
    pageTitle: {},
    lawFirm: {},
    forCreate: { type: Boolean }
  },
  emits: [
	'cancel',
	'saved',
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const resource = useLawFirm();
const errors = ref<ErrorBag>({});
const data = ref<Partial<LawFirmCreate | LawFirm>>({});

// Set data to form on mount and when the prop value changes.
const setData = () => data.value = Object.assign({}, props.lawFirm);
onMounted(setData);
watch(() => props.lawFirm, setData);

const handleCompanyRecordResult = (record: CompanyRecord) => {
	data.value.name = record.name;
};

const save = async () => {
	errors.value = {};

	const postBody: LawFirm = Object.assign({}, data.value) as LawFirm;

	let promise: Promise<LawFirm>;
	if (props.lawFirm?.id) {
		promise = resource.put(props.lawFirm.id, postBody);
	} else {
		promise = resource.post(postBody);
	}

	try {
		const response = await promise;

		emit('saved', response);

	} catch (e) {
		return handleFormError(e as Error, errors);
	}
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(PageLayout, {
    "page-title": _ctx.pageTitle,
    "base-tag": "form",
    onSubmit: _withModifiers(save, ["prevent"])
  }, _createSlots({
    "header-actions": _withCtx(() => [
      _createVNode(AppButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [
              _createTextVNode("Avbryt")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(AppButton, { type: "submit" }, {
        default: _withCtx(() => [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [
              _createTextVNode("Spara")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 2
  }, [
    (_ctx.lawFirm !== null)
      ? {
          name: "content",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _withDirectives((_openBlock(), _createElementBlock("h2", null, [
                  _createTextVNode("Information")
                ])), [
                  [_directive_translate]
                ]),
                _createVNode(AppFormGroup, {
                  id: "law_firm_identity_number",
                  errors: errors.value.identity_number,
                  label: _ctx.$gettext('Organisationsnummer')
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(data.value.id ? AppInput : AppCompanyRecordInput), {
                      id: "law_firm_identity_number",
                      modelValue: data.value.identity_number,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.value.identity_number) = $event)),
                      required: "",
                      onCompanyRecordResult: handleCompanyRecordResult
                    }, null, 40, ["modelValue"]))
                  ]),
                  _: 1
                }, 8, ["errors", "label"]),
                _createVNode(AppFormGroup, {
                  id: "law_firm_name",
                  errors: errors.value.name,
                  label: _ctx.$gettext('Namn')
                }, {
                  default: _withCtx(() => [
                    _createVNode(AppInput, {
                      id: "law_firm_name",
                      modelValue: data.value.name,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.value.name) = $event)),
                      required: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["errors", "label"])
              ]),
              (_ctx.forCreate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _withDirectives((_openBlock(), _createElementBlock("h2", null, [
                      _createTextVNode("Bjud in användare")
                    ])), [
                      [_directive_translate]
                    ]),
                    _createVNode(AppFormGroup, {
                      id: "law_firm_user",
                      errors: errors.value.user,
                      label: _ctx.$gettext('Skapa användare')
                    }, {
                      before: _withCtx(() => [
                        _createVNode(AppCheck, {
                          id: "law_firm_user",
                          modelValue: data.value.user,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.value.user) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["errors", "label"]),
                    _createVNode(AppFormGroup, {
                      id: "law_firm_invite_user_email",
                      errors: errors.value.invite_user_email,
                      label: _ctx.$gettext('E-postadress')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(AppInput, {
                          id: "law_firm_invite_user_email",
                          modelValue: data.value.invite_user_email,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.value.invite_user_email) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["errors", "label"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["page-title", "onSubmit"]))
}
}

})